import { render, staticRenderFns } from "./SchoolsView.vue?vue&type=template&id=c0f862fe&scoped=true&"
import script from "./SchoolsView.vue?vue&type=script&lang=js&"
export * from "./SchoolsView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsView.vue?vue&type=style&index=0&id=c0f862fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f862fe",
  null
  
)

export default component.exports